import { useState, useCallback } from "react";

const useColumnVisibility = (pageKey, defaultColumns) => {
  const storageKey = `sellstat_columns_${pageKey}`;

  const [visibleColumns, setVisibleColumns] = useState(() => {
    try {
      const saved = localStorage.getItem(storageKey);
      if (saved) {
        const parsed = JSON.parse(saved);
        // Merge saved prefs with defaults so new columns appear visible
        const merged = { ...defaultColumns };
        Object.keys(parsed).forEach((key) => {
          if (key in merged) merged[key] = parsed[key];
        });
        return merged;
      }
    } catch {}
    return defaultColumns;
  });

  const toggleColumn = useCallback(
    (columnKey) => {
      setVisibleColumns((prev) => {
        const updated = { ...prev, [columnKey]: !prev[columnKey] };
        localStorage.setItem(storageKey, JSON.stringify(updated));
        return updated;
      });
    },
    [storageKey]
  );

  return { visibleColumns, toggleColumn };
};

export default useColumnVisibility;
